import React, { useState, useEffect } from "react";
import SwatchImagesPDP from "./SwatchImagesPdp";
import ProductAttributes from "./ProductAttributes";
import ColorSliderPdp from "./ColorSliderPdp";
import SpecialColorSliderPdp from "./SpecialColorSliderPdp";
import "../Products.css";
import ProductBrandLogos from "./ProductBrandLogos";
// import instock_mark from "./media/instock_mark.webp";
// import popupOpener from "./media/popup_opener.webp";
import PdpGalleryPopup from "./PdpGalleryPopup";
import GravityFormDisplay from "./GravityFormDisplay";
import ProductVerticleSlider from "./ProductVerticleSlider";

export default function ProductDetailPageGravity({ product, type }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [displayPopup, setDisplayPopup] = useState("hide");
  const wpProductFilter = window.wpProductFilter;
  const wpProductCategory = window.wpProductCategory;
  const brand_collection = product.brand_collection;
  const inStock = product.in_stock ? product.in_stock : "";

  const siteInfo = window.wpProductFilter.siteInfo;
  const pdpPageLayout = siteInfo.pdpPageLayout;
  const getcouponbtn = siteInfo.getcouponbtn;
  const getcouponreplace = siteInfo.getcouponreplace;
  const getcouponreplacetext = siteInfo.getcouponreplacetext;
  const getcouponreplaceurl = siteInfo.getcouponreplaceurl;
  const show_financing = siteInfo.show_financing;
  const pdp_get_finance = siteInfo.pdp_get_finance;
  const getfinancereplace = siteInfo.getfinancereplace;
  const getcoupon_link = siteInfo.getcoupon_link;
  const showprice = siteInfo.plpshowprice;
  const current_user_id = siteInfo.current_user_id;
  const isworkbook = siteInfo.isworkbook;
  const hideinstockcoupon = siteInfo.hideinstockcoupon;
  const sale_for_only_brand = siteInfo.sale_for_only_brand;
  const sale_brand_list = siteInfo.sale_brand_list;
  const sale_brand_list_arr = Array.isArray(sale_brand_list)
    ? sale_brand_list.map((str) => str.toLowerCase())
    : [];
  const getfinancereplaceurl =
    getfinancereplace === "1"
      ? siteInfo.getfinancereplaceurl
      : "/flooring-financing/";
  const getfinancetext =
    getfinancereplace === "1" ? siteInfo.getfinancetext : "Financing";
  const manufacturerBrands = ["Bruce", "AHF", "Shaw"];
  var productManufacturer = manufacturerBrands.includes(product.manufacturer)
    ? product.brand.toLowerCase()
    : product.manufacturer.toLowerCase();
  var productManufacturer = productManufacturer.replace(/\s/g, "");
  let link_action = "add_Fav ";
  let icon_class = "fa fa-heart-o";
  let fav_text = "Add as Favorite";

  if (
    isworkbook == 1 &&
    current_user_id !== undefined &&
    current_user_id !== ""
  ) {
    let fav_details = wpProductCategory.fav_details;
    link_action = fav_details["link_action"]
      ? fav_details["link_action"]
      : "add_Fav ";
    icon_class = fav_details["icon_class"]
      ? fav_details["icon_class"]
      : "fa fa-heart-o";
    fav_text = fav_details["fav_text"]
      ? fav_details["fav_text"]
      : "Add as Favorite";
  }

  useEffect(() => {
    fetchProducts();
  }, [product]);

  const jsonld = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.name + " " + product.sku,
    image: `https://mm-media-res.cloudinary.com/image/fetch/h_600,w_600,c_limit/https://${product.swatch}`,
    description: product.name + " " + product.sku,
    sku: product.sku,
    mpn: product.sku,
    brand: {
      "@type": "thing",
      name: product.brand,
    },
    offers: {
      "@type": "offer",
      priceCurrency: "USD",
      price: "00",
      priceValidUntil: "",
    },
  };

  const fetchProducts = async () => {
    const query = new URLSearchParams({
      brand_collection: brand_collection,
      category: type,
      in_stock: inStock,
    });

    try {
      const response = await fetch(`${wpProductFilter.apiEndpoint}?${query}`);
      const data = await response.json();
      setProducts(data.products_group_by);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  const populatePopup = (status) => {
    setDisplayPopup(status);
  };

  const gravityRoot = document.getElementById("gravity-form-root");
  const productId = gravityRoot.getAttribute("data-product-id"); // Example: Pass dynamic props if needed

  return (
    <div
      className={`product_detail_wrap ${
        pdpPageLayout === "normal"
          ? "normal_pdp_layout"
          : "color_switch_pdp_layout"
      }`}>
      <div className="row productHolder">
        <div className="col-md-6 col-sm-12 product-swatch">
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
              <div className="product_gallery_slider product_verticle_gallery_slider">
                <ProductVerticleSlider product={product} />
              </div>
            </div>
            <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
              <div className="imagesHolder">
                <SwatchImagesPDP
                  swatch={product.swatch}
                  populatePopup={populatePopup}
                  height={600}
                  width={600}
                />

                <div id="roomvo">
                  <div className="roomvo-container">
                    <a
                      className="roomvo-stimr button"
                      data-sku={product.sku}
                      style={{ visibility: "hidden" }}>
                      <i className="fa fa-camera" aria-hidden="true"></i>{" "}
                      &nbsp;See In My Room
                    </a>
                  </div>
                </div>

                <script type="text/javascript">
                  {`       
                function getProductSKU() {                       
                  return "${productManufacturer}-${product.sku.toLowerCase()}";
                } 
              `}
                </script>
                <div class="image-expander">
                  <img
                    alt="zoom-img"
                    class="img"
                    src="/wp-content/plugins/mm-product-listing/build/media/popup_opener.webp"
                    onClick={(e) => populatePopup("show")}
                  />
                </div>
              </div>
            </div>
          </div>

          {pdpPageLayout === "normal" && (
            <div className="row">
              <div className="col-md-12">
                <div className="product-colors">
                  <ul>
                    <li className="found">
                      {products[Object.keys(products)[0]]?.length}
                    </li>
                    <li className="colors"> COLORS AVAILABLE </li>
                  </ul>
                </div>
                <div id="product-colors">
                  <ColorSliderPdp
                    products={products[Object.keys(products)[0]]}
                    currentProductSku={product.sku}
                  />
                </div>
              </div>
            </div>
          )}

          {pdpPageLayout !== "normal" && (
            <div className="row">
              <div className="col-md-12">
                <div className="product-colors">
                  <ul>
                    <li className="found">
                      {products[Object.keys(products)[0]]?.length}
                    </li>
                    <li className="colors"> COLORS AVAILABLE </li>
                  </ul>
                </div>
                <div id="product-colors">
                  <SpecialColorSliderPdp
                    products={products[Object.keys(products)[0]]}
                    currentProductSku={product.sku}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="button-wrapper">
            <div className="dual-button">
              <a href="/contact-us/" className="button contact-btn">
                Contact Us
              </a>

              {(pdp_get_finance != 1 || pdp_get_finance == "") && (
                <a href={getfinancereplaceurl} className="finance-btn button">
                  {getfinancetext}
                </a>
              )}
            </div>

            {getcouponbtn === "1" &&
            getcoupon_link != "" &&
            (product.in_stock == 0 ||
              (product.in_stock == 1 && hideinstockcoupon != 1)) &&
            (sale_for_only_brand == 0 ||
              sale_brand_list_arr.includes(
                product.brand_facet.toLowerCase()
              )) ? (
              <a href={getcoupon_link} className="button alt getcoupon-btn">
                <span className="fl-button-text">GET COUPON</span>
              </a>
            ) : (
              ""
            )}

            {getcouponreplace === "1" &&
            getcouponreplaceurl !== "" &&
            getcouponreplacetext !== "" ? (
              <a
                href={getcouponreplaceurl}
                className="button alt custompdpbtn getcoupon-btn">
                {getcouponreplacetext}
              </a>
            ) : (
              ""
            )}
            {isworkbook == 1 &&
            current_user_id !== undefined &&
            current_user_id !== "" ? (
              <a
                className={`button alt fl-button pdpFavbutton ${link_action}`}
                data-user={current_user_id}
                data-id={product.sku}>
                <i className={icon_class} aria-hidden="true">
                  {" "}
                </i>
                {/* <span className="">{fav_text}</span> */}
                <span class="rf">Remove From Favorite</span>
                <span class="af">Add as Favorite</span>
              </a>
            ) : (
              ""
            )}
          </div>
          <div class="row">
            <div class="col-md-12">
              <div id="product-attributes-wrap">
                <ProductAttributes product={product} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-sm-12 product-box">
          <div class="row">
            <div class="col-md-6">
              <h1 class="fl-post-title">{product.collection_name}</h1>
              <h2 class="fl-post-title">{product.color}</h2>
              {showprice == 1 && (
                <div className="price">
                  <strong>
                    <sup>$</sup>
                    {Number(product.price).toFixed(2)}
                  </strong>
                  &nbsp;/<sub>{product.price_unit}</sub>
                </div>
              )}
            </div>
            <div class=" col-md-6 text-right">
              <ProductBrandLogos product={product} />
              {product.in_stock == 1 && (
                <div class="col-lg-12 MarkInstock">
                  <img
                    src="/wp-content/plugins/mm-product-listing/build/media/instock_mark.webp"
                    className="Instock-mark"
                    alt="Instock-Mark"
                  />
                  <span>IN-STOCK</span>
                </div>
              )}
            </div>
          </div>
          <div className="formWrapperPdp">
            <GravityFormDisplay productId={productId} />
          </div>
        </div>
      </div>

      {/* <div className={`pdpGalleryImagePopup ${displayPopup}`}> */}
      <div className={`pdpGalleryImagePopup ${displayPopup}`}>
        <div className="closePopup">
          <span onClick={(e) => populatePopup("hide")}>X</span>
        </div>
        <PdpGalleryPopup
          swatch={product.swatch}
          galleryImages={product.gallery_images}
          height={800}
          width={800}
          productName={`${product.name} ${product.sku}`}
        />
      </div>

      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
    </div>
  );
}
